import Reflux from 'reflux';

export default Reflux.createActions([
  'getList',
  'getListComplete',
  'changeList'
]);



// WEBPACK FOOTER //
// ./src/js/actions/StudentOverview.js